import { render, staticRenderFns } from "./simOpen.vue?vue&type=template&id=524d8cfe&scoped=true&"
import script from "./simOpen.vue?vue&type=script&lang=js&"
export * from "./simOpen.vue?vue&type=script&lang=js&"
import style0 from "./simOpen.vue?vue&type=style&index=0&id=524d8cfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d8cfe",
  null
  
)

export default component.exports